import { Accordion, AccordionItem } from "@heroui/react";
import { createFileRoute } from "@tanstack/react-router";
import FieldManagement from "@/components/field/setup/FieldManagement";
import ManagementZones from "@/components/field/setup/ManagementZones";
import ChemigationSystems from "@/components/field/setup/ChemigationSystems";
import FertilizerPreferences from "@/components/field/setup/FertilizerPreferences";
import TreatmentSectors from "@/components/field/setup/TreatmentSectors";
import IrrigationSystems from "@/components/field/setup/IrrigationSystems";
import { useTranslation } from "react-i18next";
import useAuth from "@/lib/auth/useAuth";
import { Resource } from "@/types/user";
export const Route = createFileRoute("/dashboard/fields/$fieldId/setup")({
    component: RouteComponent,
});

function RouteComponent() {
    const { t } = useTranslation("setup");
    const { isAtLeastDetail } = useAuth();
    return (
        <Accordion>
            <AccordionItem key="field" title={t("field_management.title")}>
                <FieldManagement />
            </AccordionItem>
            <AccordionItem
                key="management-zones"
                title={t("management_zones.title")}
            >
                <ManagementZones />
            </AccordionItem>
            <AccordionItem
                key="irrigation-system"
                title={t("irrigation_system.title")}
            >
                <IrrigationSystems />
            </AccordionItem>
            <AccordionItem
                key="chemigation-systems"
                title={t("chemigation_systems.title")}
            >
                <ChemigationSystems />
            </AccordionItem>
            <AccordionItem
                key="fertilizer-preferences"
                title={t("fertilizer_preferences.title")}
            >
                <FertilizerPreferences />
            </AccordionItem>
            {isAtLeastDetail(Resource.TREATMENT_SECTORS) ? (
                <AccordionItem
                    key="treatment-sectors"
                    title={t("treatment_sectors.title")}
                >
                    <TreatmentSectors />
                </AccordionItem>
            ) : null}
        </Accordion>
    );
}
